import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './ServiceCategoriesEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class ServiceCategoriesEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    sc_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    sc_Input_Description_MultiLang: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.ServiceCategory_LoadData>>>;
    sc_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    sc_Input_TextColor: HTMLInputElement;
    sc_Input_BackgroundColor: HTMLInputElement;
    sc_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;
    sc_Checkbox_EvTaskCreate: MdsLax<InstanceType<typeof CheckBox>>;

    formData: MainCatalogTypes.ServiceCategory_SaveData = {
        ID: "",
        is_new_status: null,
        description: "",
        note: "",
        order: null,
        coloration: null,
        is_ev_task_create: null,
        __multilang: {}
    };

    prepareFormData(data?: MainCatalogTypes.ServiceCategory_LoadData): void {

        if (data) {

            //this.sc_Input_Description.setValue(data.description, true);
            this.sc_Input_Description_MultiLang.setValue({ entity: data, targetAttribute: "description" }, true);
            this.sc_Input_Note.setValue(data.note, true);

            this.sc_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.sc_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.sc_Input_Order.setValue(data.order, true);

            this.sc_Checkbox_EvTaskCreate.setValue(data.is_ev_task_create, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            //this.sc_Input_Description.setValue("", true);
            this.sc_Input_Description_MultiLang.setValue({ entity: null, targetAttribute: "description" }, true);
            this.sc_Input_Note.setValue("", true);

            this.sc_Input_BackgroundColor.value = "#ffffff";
            this.sc_Input_TextColor.value = "#000000";

            this.sc_Input_Order.setValue(null, true);

            this.sc_Checkbox_EvTaskCreate.setValue(false, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {

        //this.formData.__multilang["description"] = this.sc_Input_Description_MultiLang.getValue();
        this.sc_Input_Description_MultiLang.getValueOntoEntity(this.formData as any);
        //this.formData.description = this.sc_Input_Description.getValue();
        this.formData.note = this.sc_Input_Note.getValue();

        this.formData.order = this.sc_Input_Order.getValue();

        this.formData.is_ev_task_create = this.sc_Checkbox_EvTaskCreate.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.sc_Input_TextColor.value;
        let backHex = this.sc_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeServiceCategoryInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.sc_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        //if (!this.formData.description) b = false;

        return b;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.ServiceCategory;

        this.sc_Input_Description.setMaxLength(255);
        this.sc_Input_Note.setMaxLength(2000);
        this.sc_Input_Note.setValidationEnabled(false);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(ServiceCategoriesEditor.prototype, {
  sc_Input_Description: () => (new Edit()),
  sc_Input_Note: () => (new Edit()),
  sc_Input_Order: () => (new NumberInput()),
  sc_Checkbox_EvTaskCreate: () => (new CheckBox()),
});
export default mdsWidget(ServiceCategoriesEditor);